var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.15,8.18c-.14.11-2.6,1.49-2.6,4.57,0,3.56,3.13,4.82,3.22,4.85-.01.08-.5,1.73-1.65,3.41-1.03,1.48-2.1,2.95-3.73,2.95s-2.05-.95-3.94-.95-2.49.98-3.98.98-2.53-1.37-3.73-3.05c-1.39-1.97-2.51-5.04-2.51-7.95,0-4.67,3.03-7.14,6.02-7.14,1.59,0,2.91,1.04,3.91,1.04s2.43-1.1,4.23-1.1c.68,0,3.14.06,4.76,2.38h0ZM15.53,3.83c.75-.89,1.27-2.11,1.27-3.34,0-.17-.01-.34-.05-.48-1.21.05-2.66.81-3.53,1.82-.68.78-1.32,2.01-1.32,3.25,0,.19.03.37.05.43.08.01.2.03.33.03,1.09,0,2.46-.73,3.25-1.71h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e68c756ed2a467305222a25b6f7b7314.svg";
export { ForwardRef as ReactComponent };